// Main layout component
export { default as ElementLayout } from './element-layout/ElementLayout';

// Navigation components
export { TopNavigationBar } from './side-bars/main-sidebar/TopNavigationBar';
export { default as UnifiedSidebar } from './side-bars/main-sidebar/UnifiedSidebar';

// Page layout components
export { PageLayout } from './page-layout';
export type { PageRow, PageLayoutConfig } from './page-layout';

// Page container components
export { UnifiedItemsContainer } from './page-containers';
export type { 
  PageHandlers, 
  TransformContext, 
  StoreOperations,
  ItemType,
  UnifiedItemsContainerProps,
} from './page-containers';

// Edit mode components
export { default as EditModeControls } from './element-layout/EditModeControls';
export { default as ElementEditor } from './element-layout/ElementEditor';

// Types and interfaces
export type {
  LayoutElement,
  LayoutElementType,
  LayoutConfig,
  ElementLayoutProps,
  EditModeProps,
} from './element-layout/layoutTypes';

// Predefined components registry
export { layoutElements } from './element-layout/LayoutElements';
export { default as LayoutElements } from './element-layout/LayoutElements';

// Available component types for reference - only widgets
export const AVAILABLE_ELEMENT_TYPES = [
  'row-layout-1',
  'row-layout-2',
  'row-layout-3',
  'row-layout-4',
  'stats-widget',
  'list-widget',
  'table-widget',
  'expandable-table-widget',
  'title-widget',
  'text-field-widget',
  'chart-widget',
  'form-widget',
  'calendar-widget',
  'notification-widget',
  'progress-widget',
  'media-widget',
  'grid-widget',
  'types-widget',
  'tags-widget',
  'tms-table-widget',
] as const; 